import LoginPage from '../../components/LoginPage';
import AcceptAppointment from '../../components/appointment/AcceptAppointment';
import RejectAppointment from '../../components/appointment/RejectAppointment';
import About from '../../components/About';
import CallPage from '../../components/call/CallPage';
import CallFeedback from '../../components/call/CallFeedback';
import AccountSetupPage from '../../components/accountSetup/AccountSetupPage';
import { RouteObject } from 'react-router';

export const publicRoutes: RouteObject[] = [
  { index: true, element: <LoginPage /> },
  { path: 'about', element: <About /> },
  { path: 'account-setup', element: <AccountSetupPage /> },
  { path: 'teletherapie/accept/:appointmentId', element: <AcceptAppointment /> },
  { path: 'teletherapie/reject/:appointmentId', element: <RejectAppointment /> },
  { path: 'call-feedback/:code/:isTherapist', element: <CallFeedback /> },
  { path: 'call/:roomCode', element: <CallPage /> },
];
